import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import styled from 'styled-components';
import { PlatformCode, PlatformENName, PlatformKRName } from 'type/common';

import useGetSearchParams from 'hooks/useGetSearchParams';
import CoreRadioChips from 'shared/chips/CoreRadioChips';
import { StickySectionFilter } from 'styles/styled-components/section';
import style from 'styles/styled-components/style';
import { platform_KR_to_code_mapper } from 'utils/platformMapper';

import OrdinalFilter from './filter/OrdinalFilter';

const platform_arr = ['인스타그램', '유튜브'];
const name_mapper: Record<PlatformCode, PlatformKRName> = {
	ig: '인스타그램',
	yt: '유튜브',
};

const FilterRow = () => {
	const [platform] = useGetSearchParams(['platform']);
	const [searchParams, setSearchParams] = useSearchParams();

	const selectedPlatform = name_mapper[platform as PlatformCode] ?? '';

	/** 플랫폼 칩 선택 */
	const setPlatformChips = (platform_name: string) => {
		searchParams.set(
			'platform',
			platform_KR_to_code_mapper[platform_name as PlatformKRName] as string,
		);
		setSearchParams(searchParams, { replace: true });
	};

	useEffect(() => {
		if (!platform) {
			searchParams.set('platform', 'ig');
			setSearchParams(searchParams, { replace: true });
		}
	}, [platform, searchParams]);

	return (
		<StickySectionFilter _padding="16px">
			<Grid flex="between">
				<Grid _width="200px" flex="between" align_items="end">
					<OrdinalFilter />
				</Grid>
				<Seperator />

				<Grid flex="start">
					<CoreRadioChips
						group_type="carousel"
						style_type="default"
						_width="max-content"
						chips_list={platform_arr}
						selected_chips={selectedPlatform}
						setSelectedChips={setPlatformChips}
						_disabled={[]}
					/>
				</Grid>
			</Grid>
		</StickySectionFilter>
	);
};

const { Grid } = style;

export default FilterRow;

const Seperator = styled.div`
	position: relative;
	width: 1px;
	height: 24px;
	background-color: rgb(222, 226, 230);
	margin: 0 16px;
`;
